// 主登入頁面翻譯
import registerModule from "./register.js";
import forgotModule from "./forgot.js";
import verifyModule from "./verify.js";
import bindingModule from "./binding.js";
import codegoogleModule from "./codegoogle.js";

// 主登入頁面內容
const main = {
  // 頁面標題和歡迎信息
  title: "用戶登入",
  welcome: "歡迎使用圖鏈系統",
  subtitle: "請輸入您的帳號信息",

  // 表單字段
  username: "用戶名",
  password: "密碼",
  usernamePlaceholder: "請輸入用戶名",
  passwordPlaceholder: "請輸入密碼",

  // 按鈕和鏈接
  login: "登 入",
  loginButton: "立即登入",
  forgotPassword: "忘記密碼？",
  noAccount: "還沒有帳戶？",
  register: "註冊",
  accountLoginTab: "帳號登入",
  phoneLoginTab: "手機登入",
  confirm: "確認",
  returnToLogin: "返回登入",

  // 驗證碼相關
  verificationCode: "驗證碼",
  verificationCodePlaceholder: "請輸入驗證碼",
  identityVerificationTitle: "身分驗證碼",
  howToUseAuthenticator: "如何使用身分驗證器？",
  howToViewGoogleAuth: "如何查看谷歌驗證碼？",
  howToUseGoogleCode: "如何使用谷歌驗證碼",
  googleAuthBinding: "谷歌驗證器綁定",

  // 消息提示
  loginSuccess: "登入成功",
  loginFailed: "登入失敗",
  verificationTimeExpired: "驗證時間已過期，請重新登入",
  loading: "加載中",

  // 表單驗證
  usernameRequired: "請輸入用戶名",
  passwordRequired: "請輸入密碼",
  usernameLength: "用戶名長度應在2-20個字符之間",
  passwordLength: "密碼長度應在2-16個字符之間",
  verificationCodeRequired: "請輸入驗證碼",
  verificationCodeLength: "驗證碼長度應在2-5個字符之間",
  phoneRequired: "請輸入手機號碼",
  phoneFormatError: "請輸入正確的手機號碼格式",
  smsCodeRequired: "請輸入驗證碼",
  smsCodeLength: "驗證碼長度為4-6位",

  // 其他
  rememberMe: "記住我",
  switchToRegister: "還沒有帳號？立即註冊",
  welcomeBack: "歡迎回來",
  resendCaptcha: "重新發送({time})",
  captchaSentSuccess: "驗證碼已發送，請注意查收",
  successDialog: {
    defaultTitle: "操作成功",
    defaultSubtitle: "添加企業微信申請更多服務",
    defaultConfirm: "確定",
  },
};

export default {
  ...main,
  // 子模組
  registerModule,
  forgotModule,
  verifyModule,
  bindingModule,
  codegoogleModule,
};
